export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'message_delete',
  'waha_status_manage',
  'contact_sidebar_edit',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const MESSAGE_DELETE_PERMISSIONS = 'message_delete';

export const WAHA_STATUS_MANAGE_PERMISSIONS = 'waha_status_manage';

export const CONTACT_SIDEBAR_EDIT_PERMISSIONS = 'contact_sidebar_edit';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  unread: {
    count: 'unreadCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  favorites: {
    count: 'favoritesCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  groups: {
    count: 'groupsCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
